import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { declineNumber } from '../../../utils/language';

// Path to the local SVG sprite in the 'public' folder.
const iconsSprite = '/icons/available_icons.svg';

const Availbility = ({availbility = []}) => {
    const { t } = useTranslation();
    const renderCheckMark = (qtyAvailable, deliveryQty, deliveryDays) => {
        if (+qtyAvailable > 0 ) {
            return (
                <>
                    <svg width="24" height="24">
                        <use href={`${iconsSprite}#icon-check-img`}></use>
                    </svg>
                    <Trans i18nKey="today" />
                </>
            );
        }

        if (+deliveryQty > 0) {
            return (
                <>
                    <svg width="24" height="24">
                        <use href={`${iconsSprite}#icon-hourglass-img`}></use>
                    </svg>
                    {declineNumber(deliveryDays, t('day'), t('days'), t('days'))}
                </>
            );
        }

        return false;
    };

    const renderAvailabilityIcon = (isExposed) => {
        const iconId = isExposed === 'Yes' ? '#icon-dot-green-img' : '#icon-dot-grey-img';
        return (
            <svg width="24" height="24" aria-label={isExposed}>
                <use href={`${iconsSprite}${iconId}`}></use>
            </svg>
        );
    };


    return (
        <div>
            <ul className="delivery-accordion__content-header delivery-accordion-row">
                <li className='name'>
                    <Trans i18nKey="product.shop" />
                </li>
                <li className="delivery-accordion__menu-with-icon available">
                    <Trans i18nKey="Availability / Pickup time" />
                </li>
                <li className="delivery-accordion__menu-with-icon availability">
                    <Trans i18nKey="product.availabilityExposed" />
                </li>
            </ul>

            {
                availbility
                    .filter(({isMP = false}) => {
                        return isMP == true
                    })
                    .map(({available, qtyAvailable, deliveryFrom, isExposed, siteName, deliveryQty, deliveryDays}) => (
                        <ul key={siteName} className="delivery-accordion-row">
                            <li className='name'>{siteName}</li>
                            <li className='available'>{renderCheckMark(qtyAvailable, deliveryQty, deliveryDays)}</li>
                            <li className='availability'>
                                {renderAvailabilityIcon(isExposed)}
                            </li>
                        </ul>
                    ))
            }
            <ul className='legend'>
                <li>
                    <svg width="24" height="24">
                        <use href={`${iconsSprite}#icon-check-img`}></use>
                    </svg>
                    <Trans i18nKey="Available immediately" /></li>
                <li>
                    <svg width="24" height="24">
                        <use href={`${iconsSprite}#icon-hourglass-img`}></use>
                    </svg>
                    <Trans i18nKey="Time needed for the item to arrive" />
                </li>
                <li>
                    <svg width="24" height="24">
                        <use href={`${iconsSprite}#icon-dot-green-img`}></use>
                    </svg>
                    <Trans i18nKey="Displayed" />
                </li>
                <li>
                    <svg width="24" height="24">
                        <use href={`${iconsSprite}#icon-dot-grey-img`}></use>
                    </svg>
                    <Trans i18nKey="Not displayed" />
                </li>
            </ul>
            <Trans i18nKey="Pickup is possible after receiving confirmation" />

        </div>
    )
};

export default Availbility;
